"use client";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { PrimaryButton } from "ui/components";

export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="fr">
      <head />
      <body>
        <h2 className="mb-2">Une erreur est survenue.</h2>
        <PrimaryButton type="button" onClick={() => unstable_retry()}>
          Réessayer
        </PrimaryButton>
      </body>
    </html>
  );
}
